import axios from 'axios'
import storage from 'store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'

const ACCESS_TOKEN = 'Access-Token'
// import store from '@/store'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_SERVER_URL : process.env.VUE_APP_API_BASE_URL,
  // baseURL: '/api',
  timeout: 6000 // 请求超时时间

})
console.log('========>', process.env)
// 异常拦截处理器
const errorHandler = (error) => {
  console.log('错误拦截=========>', error)
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 400) {
      notification.error({
        message: 'Bad Request',
        description: data.message
      })
    }
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    console.log('request=====>', error)
    if (error.response.status === 401) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        storage.remove(ACCESS_TOKEN)
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Access-Token'] = token
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js